/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {UserSearchesReplaceRequest} from '../models/UserSearchesReplaceRequest';
import type {UserSearchesReplaceResponse} from '../models/UserSearchesReplaceResponse';

export interface UserSavedSearchesReplaceV2$Request {
    userId: number;
    userSearchesReplaceRequest: UserSearchesReplaceRequest;
}

export interface UserSavedSearchesReplaceV2$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const userSavedSearchesReplaceV2Request = createAction<PayloadData<void, UserSavedSearchesReplaceV2$Request>>('USER_SAVED_SEARCHES_REPLACE_V2__USER_SAVED_SEARCHES_REPLACE_V2__REQUEST');
export const userSavedSearchesReplaceV2Success = createAction<PayloadData<UserSearchesReplaceResponse, UserSavedSearchesReplaceV2$Request>>('USER_SAVED_SEARCHES_REPLACE_V2__USER_SAVED_SEARCHES_REPLACE_V2__SUCCESS');
export const userSavedSearchesReplaceV2Failure = createAction<PayloadData<Error, UserSavedSearchesReplaceV2$Request, true>>('USER_SAVED_SEARCHES_REPLACE_V2__USER_SAVED_SEARCHES_REPLACE_V2__FAILURE');

export const userSavedSearchesReplaceV2Actions = [
    userSavedSearchesReplaceV2Request,
    userSavedSearchesReplaceV2Success,
    userSavedSearchesReplaceV2Failure
] as const;

/**
 * @param {number} meta.userId
 * @param {UserSearchesReplaceRequest} meta.userSearchesReplaceRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const userSavedSearchesReplaceV2 = (meta: UserSavedSearchesReplaceV2$Request, config?: UserSavedSearchesReplaceV2$Config) => {
    return {
        CALL_API: {
            types: userSavedSearchesReplaceV2Actions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/v2/users/${meta.userId}/saved-searches/replace`,
            TRANSPORT_REQUEST_BODY: meta.userSearchesReplaceRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

